import { FormInstance } from "antd";
import { useAppSelector } from "store/hook";
import { SYSTEM } from "Utility/Types/status_identity_get_set";

export const setFields = (alarm: SYSTEM["alarm"], form: FormInstance<any>) => {
  let isLatFloat = alarm?.geofence?.latitude;
  let isLongFloat = alarm?.geofence?.longitude;

  form.setFieldsValue({
    alarm_enabled: alarm?.mode || false,
    alarm_input: alarm?.inputs || ["sms"],
    gps_reference: alarm?.geofence?.auto_detect || false,
    gps_radius: alarm?.geofence?.radius_m || 150,
    gps_latitude: IsFloat(isLatFloat) ? isLatFloat : 0.00001,
    gps_longitude: IsFloat(isLongFloat) ? isLongFloat : 0.00001,
    di_d1_trigger:
      alarm?.digital_inputs?.[0]?.trigger?.charAt(0).toUpperCase() + alarm?.digital_inputs?.[0]?.trigger?.slice(1) ||
      "high",
    di_d2_trigger:
      alarm?.digital_inputs?.[1]?.trigger?.charAt(0).toUpperCase() + alarm?.digital_inputs?.[1]?.trigger?.slice(1) ||
      "high",
    cpu_high: alarm?.thermal?.high || 95,
    cpu_low: alarm?.thermal?.low || -40,
  });
};

const IsFloat = (n: any) => Number(n) === n && n % 1 !== 0;

export interface SYSTEMProps {
  SubmitConfigonFinish: (value: any) => void;
  form: FormInstance<any>;
}
